import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type AccordionData = {
  title: string
  content: string
  marginBottom: string
}

export const accordion: DynamicContentType<AccordionData> = {
  name: 'accordion',
  viewName: 'Accordion',
  featureKey: 'accordion',
  icon: LucideIconName.ListChevronsDownUp,
  default: true,
  uuid: '',
  data: {
    title: 'Min titel',
    content: '<p>Mitt textinnehåll</p>',
    marginBottom: '0.5rem',
  },
}
